import React from 'react';
import { Video, MessageCircle, Phone, Mail } from 'lucide-react';

const sessionTypeConfig = {
  chat: { label: 'Chat', icon: MessageCircle, color: 'bg-[#4A5D4E]' },
  video: { label: 'Vídeo', icon: Video, color: 'bg-[#6B8E7C]' },
  call: { label: 'Ligação', icon: Phone, color: 'bg-[#D4A373]' },
  email: { label: 'Email', icon: Mail, color: 'bg-[#9B8BAE]' }
};

export function getSessionConfig(type) {
  return sessionTypeConfig[type] || null;
}

export function getStatusLabel(status) {
  const labels = { completed: 'Concluída', in_progress: 'Em andamento', scheduled: 'Agendada' };
  return labels[status] || 'Pendente';
}

export function getStatusColor(status) {
  if (status === 'completed') return 'bg-[#6B8E7C]/10 text-[#6B8E7C]';
  if (status === 'in_progress') return 'bg-[#D4A373]/10 text-[#D4A373]';
  return 'bg-[#A0A09A]/10 text-[#A0A09A]';
}

export function SessionTypeMessage({ session }) {
  const { session_type, status, video_room_url, user_email } = session;

  if (session_type === 'video' && !video_room_url) {
    return (
      <div>
        <Video className="w-16 h-16 mx-auto text-[#6B8E7C] mb-4" strokeWidth={1} />
        <h3 className="text-xl font-medium text-[#292927] mb-2" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
          Sessão por Vídeo
        </h3>
        <p className="text-[#63635E]">
          {status === 'scheduled' ? 'Aguardando o profissional iniciar a sessão...' : 'A sala de vídeo será criada quando a sessão iniciar.'}
        </p>
      </div>
    );
  }

  if (session_type === 'email') {
    return (
      <div>
        <Mail className="w-16 h-16 mx-auto text-[#9B8BAE] mb-4" strokeWidth={1} />
        <h3 className="text-xl font-medium text-[#292927] mb-2" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
          Sessão por Email
        </h3>
        <p className="text-[#63635E]">O profissional entrará em contato via email: {user_email}</p>
      </div>
    );
  }

  if (session_type === 'call') {
    return (
      <div>
        <Phone className="w-16 h-16 mx-auto text-[#D4A373] mb-4" strokeWidth={1} />
        <h3 className="text-xl font-medium text-[#292927] mb-2" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
          Sessão por Ligação
        </h3>
        <p className="text-[#63635E]">O profissional entrará em contato no horário agendado.</p>
      </div>
    );
  }

  return (
    <div>
      <MessageCircle className="w-16 h-16 mx-auto text-[#4A5D4E] mb-4" strokeWidth={1} />
      <h3 className="text-xl font-medium text-[#292927] mb-2" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
        Chat da Sessão
      </h3>
      <p className="text-[#63635E]">
        {status === 'scheduled' ? 'Aguardando o profissional iniciar a sessão...' : 'O chat será disponibilizado quando a sessão iniciar.'}
      </p>
    </div>
  );
}
